// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"45cdfbe6","455":"5a1093f9"}[chunkId] + ".chunk.js";
};